var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-main-operation-logo-container",
      class: { collapse: _vm.collapse },
    },
    [
      _c(
        "transition",
        { attrs: { name: "sidebarLogoFade" } },
        [
          true
            ? _c(
                "router-link",
                {
                  key: "collapse",
                  staticClass: "sidebar-main-operation-logo-link",
                  attrs: { to: "/" },
                },
                [
                  _c("img", {
                    staticClass: "sidebar-main-operation-logo",
                    attrs: { src: _vm.logo },
                  }),
                ]
              )
            : _c(
                "router-link",
                {
                  key: "expand",
                  staticClass: "sidebar-main-operation-logo-link",
                  attrs: { to: "/" },
                },
                [
                  _c("img", {
                    staticClass: "sidebar-main-operation-logo",
                    attrs: { src: _vm.logo },
                  }),
                ]
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }